export default class TableSelectRow {
    public id: string = "";
    public values: { [key: string]: any } = {};
}